/**
 * Model configuration
 */
export const config = {
  modelName: 'time',
} as const;
